<div class="container content-box module-content">
  <div class="bean-container bean-counting">
      <div class="text-center">
          <h1>Activity</h1>
      </div>
      <hr>
      <h4>Description</h4>
      <p>This activity will help you with budgeting when deciding what priorities to take when deciding where to live.</p>
      <h4>Instructions</h4>
      <ol class="instructions-list">
          <li class="instructions-item">With a 28-bean “budget” to spend, choose your priorities for choosing a rental unit. Select a single priority in each row. Each choice will decrease your budget by that amount. Try not to go to a negative balance. Your goal is
              to have a choice in each row and finish with a positive balance.
          </li>

      </ol>
      <div class="game">
          <div #stickyMenu [class.sticky]="sticky">
              <div class="text-center activity-header" [ngClass]="balance >= 0 ? 'activity-header-success': 'activity-header-failure'">
                  <h1>Balance: {{ balance }}</h1>
              </div>

          </div>
          <div class="beans">


              <strong>Type of Housing:</strong>

              <div class="bean-row">
                  <label>
                          <input type="radio" name="priority1" [value]="1" [(ngModel)]="model.priority1" (click)="selectQ1()" (change)="updateOne()"/> <b>(-1)</b> <br>Multifamily; heavy traffic; includes mobile home park
                      </label>
                  <label>
                          <input type="radio" name="priority1" [value]="2" [(ngModel)]="model.priority1" (click)="selectQ1()" (change)="updateOne()"/> <b>(-2)</b> <br>Multifamily or single family; moderate  traffic
                      </label>
                  <label>
                          <input type="radio" name="priority1" [value]="3" [(ngModel)]="model.priority1" (click)="selectQ1()" (change)="updateOne()"/> <b>(-3)</b> <br>Prime location; single family; light traffic
                      </label>
              </div>

              <strong>Neighborhood facilities</strong> (park or play-ground, paved streets, sewer system, street lighting):

              <div class="bean-row">
                  <label>
                          <input type="radio" name="priority2" [value]="1" [(ngModel)]="model.priority2" (click)="selectQ2()" (change)="updateTwo()"/> <b>(-1)</b> <br>Few facilities
                      </label>
                  <label>
                          <input type="radio" name="priority2" [value]="2" [(ngModel)]="model.priority2" (click)="selectQ2()" (change)="updateTwo()"/>  <b>(-2)</b> <br>Some facilities available
                      </label>
                  <label>
                          <input type="radio" name="priority2" [value]="3" [(ngModel)]="model.priority2" (click)="selectQ2()" (change)="updateTwo()"/> <b>(-3)</b> <br>All facilities available
                      </label>
              </div>

              <strong>Transportation:</strong>

              <div class="bean-row">
                  <label>
                          <input type="radio" name="priority3" [value]="1" [(ngModel)]="model.priority3" (click)="selectQ3()" (change)="updateThree()"/> <b>(-1)</b> <br>Within four blocks of bus stops
                      </label>
                  <label>
                          <input type="radio" name="priority3" [value]="2" [(ngModel)]="model.priority3" (click)="selectQ3()" (change)="updateThree()"/> <b>(-2)</b> <br>Bus stop within two blocks and/or street parking
                      </label>
                  <label>
                          <input type="radio" name="priority3" [value]="3" [(ngModel)]="model.priority3" (click)="selectQ3()" (change)="updateThree()"/> <b>(-3)</b> <br>On bus line and/or includes an assigned heated parking space
                      </label>
              </div>

              <strong>Privacy:</strong>

              <div class="bean-row">
                  <label>
                          <input type="radio" name="priority4" [value]="1" [(ngModel)]="model.priority4" (click)="selectQ4()" (change)="updateFour()"/> <b>(-1)</b> <br>Little privacy, lots of noise between units
                      </label>
                  <label>
                          <input type="radio" name="priority4" [value]="2" [(ngModel)]="model.priority4" (click)="selectQ4()" (change)="updateFour()"/> <b>(-2)</b> <br>Little noise from neighbors; some street noise
                      </label>
                  <label>
                          <input type="radio" name="priority4" [value]="3" [(ngModel)]="model.priority4" (click)="selectQ4()" (change)="updateFour()"/> <b>(-3)</b> <br>Cannot hear other tenants or noise from neighborhood activities
                      </label>
              </div>

              <strong>Safety and Security:</strong>

              <div class="bean-row">
                  <label>
                          <input type="radio" name="priority5" [value]="1" [(ngModel)]="model.priority5" (click)="selectQ5()" (change)="updateFive()"/>  <b>(-1)</b> <br>High crime rate in neighborhood
                      </label>
                  <label>
                          <input type="radio" name="priority5" [value]="2" [(ngModel)]="model.priority5" (click)="selectQ5()" (change)="updateFive()"/>  <b>(-2)</b> <br>Medium crime rate with good police patrols
                      </label>
                  <label>
                          <input type="radio" name="priority5" [value]="3" [(ngModel)]="model.priority5" (click)="selectQ5()" (change)="updateFive()"/> <b>(-3)</b> <br> Low crime rate and/or secure building
                      </label>
              </div>

              <strong>Location:</strong>

              <div class="bean-row">
                  <label>
                          <input type="radio" name="priority6" [value]="1" [(ngModel)]="model.priority6" (click)="selectQ6()" (change)="updateSix()"/> <b>(-1)</b> <br>Must travel more than 30 minutes to work, child care, and retail
                      </label>
                  <label>
                          <input type="radio" name="priority6" [value]="2" [(ngModel)]="model.priority6" (click)="selectQ6()" (change)="updateSix()"/> <b>(-2)</b> <br>Close to retail and other services; more than 20 minutes to work
                      </label>
                  <label>
                          <input type="radio" name="priority6" [value]="3" [(ngModel)]="model.priority6" (click)="selectQ6()" (change)="updateSix()"/> <b>(-3)</b> <br>Within five miles of work, child care, school, and grocery store
                      </label>
              </div>

              <strong>Size of rooms:</strong>

              <div class="bean-row">
                  <label>
                          <input type="radio" name="priority7" [value]="1" [(ngModel)]="model.priority7" (click)="selectQ7()" (change)="updateSeven()"/> <b>(-1)</b> <br>Small
                      </label>
                  <label>
                          <input type="radio" name="priority7" [value]="2" [(ngModel)]="model.priority7" (click)="selectQ7()" (change)="updateSeven()"/> <b>(-2)</b> <br>Medium
                      </label>
                  <label>
                          <input type="radio" name="priority7" [value]="3" [(ngModel)]="model.priority7" (click)="selectQ7()" (change)="updateSeven()"/> <b>(-3)</b> <br>Large
                      </label>
              </div>

              <strong>Laundromat:</strong>

              <div class="bean-row">
                  <label>
                          <input type="radio" name="priority8" [value]="2" [(ngModel)]="model.priority8" (click)="selectQ8()" (change)="updateEight()"/>  <b>(-2)</b> <br>Within walking distance
                      </label>
                  <label>
                          <input type="radio" name="priority8" [value]="3" [(ngModel)]="model.priority8" (click)="selectQ8()" (change)="updateEight()"/> <b>(-3)</b> <br>Coin-operated machines in building
                      </label>
                  <label>
                          <input type="radio" name="priority8" [value]="4" [(ngModel)]="model.priority8" (click)="selectQ8()" (change)="updateEight()"/> <b>(-4)</b> <br>Washer and dryer in unit
                      </label>
              </div>

              <strong>Bathrooms:</strong>

              <div class="bean-row">
                  <label>
                          <input type="radio" name="priority9" [value]="1" [(ngModel)]="model.priority9" (click)="selectQ9()" (change)="updateNine()"/> <b>(-1)</b> <br>1 full
                      </label>
                  <label>
                          <input type="radio" name="priority9" [value]="2" [(ngModel)]="model.priority9" (click)="selectQ9()" (change)="updateNine()"/> <b>(-2)</b> <br>1 ½ to 2 bathrooms
                      </label>
                  <label>
                          <input type="radio" name="priority9" [value]="4" [(ngModel)]="model.priority9" (click)="selectQ9()" (change)="updateNine()"/> <b>(-4)</b> <br>2 ½ to 3 bathrooms
                      </label>
              </div>

              <strong>Number of bedrooms:</strong>

              <div class="bean-row">
                  <label>
                          <input type="radio" name="priority10" [value]="1" [(ngModel)]="model.priority10" (click)="selectQ10()" (change)="updateTen()"/> <b>(-1)</b> <br>2 bedrooms
                      </label>
                  <label>
                          <input type="radio" name="priority10" [value]="2" [(ngModel)]="model.priority10" (click)="selectQ10()" (change)="updateTen()"/> <b>(-2)</b> <br>3 bedrooms
                      </label>
                  <label>
                          <input type="radio" name="priority10" [value]="3" [(ngModel)]="model.priority10" (click)="selectQ10()" (change)="updateTen()"/> <b>(-3)</b> <br>4 or more bedrooms
                      </label>
              </div>

              <strong>Management:</strong>

              <div class="bean-row">
                  <label>
                          <input type="radio" name="priority11" [value]="1" [(ngModel)]="model.priority11" (click)="selectQ11()" (change)="updateEleven()"/> <b>(-1)</b> <br>No property manager onsite
                      </label>
                  <label>
                          <input type="radio" name="priority11" [value]="2" [(ngModel)]="model.priority11" (click)="selectQ11()" (change)="updateEleven()"/> <b>(-2)</b> <br>Well-known, respected, local management
                      </label>
                  <label>
                          <input type="radio" name="priority11" [value]="3" [(ngModel)]="model.priority11" (click)="selectQ11()" (change)="updateEleven()"/>  <b>(-3)</b> <br>Responsible property manager lives onsite
                      </label>
              </div>

              <strong>Opportunities for children:</strong>

              <div class="bean-row">
                  <label>
                          <input type="radio" name="priority12" [value]="1" [(ngModel)]="model.priority12" (click)="selectQ12()"(change)="updateTwelve()"/>  <b>(-1)</b> <br>No outside play areas; neighbors complain if children are noisy
                      </label>
                  <label>
                          <input type="radio" name="priority12" [value]="2" [(ngModel)]="model.priority12" (click)="selectQ12()"(change)="updateTwelve()"/>  <b>(-2)</b> <br>Children have outside areas; other children for play
                      </label>
                  <label>
                          <input type="radio" name="priority12" [value]="3" [(ngModel)]="model.priority12" (click)="selectQ12()" (change)="updateTwelve()"/> <b>(-3)</b> <br>Children have indoor and outdoor opportunities to play with others; have a space of their own
                      </label>
              </div>

              <strong>Quality of interior materials</strong> (agoor cover-ings, wall treatments , cabinetry, lighting):

              <div class="bean-row">
                  <label>
                          <input type="radio" name="priority13" [value]="1" [(ngModel)]="model.priority13" (click)="selectQ13()" (change)="updateThirteen()"/> <b>(-1)</b> <br>Basic, minimum
                      </label>
                  <label>
                          <input type="radio" name="priority13" [value]="2" [(ngModel)]="model.priority13" (click)="selectQ13()" (change)="updateThirteen()"/> <b>(-2)</b> <br>Average quality
                      </label>
                  <label>
                          <input type="radio" name="priority13" [value]="3" [(ngModel)]="model.priority13" (click)="selectQ13()" (change)="updateThirteen()"/> <b>(-3)</b> <br>Good quality; clean; pleasing colors
                      </label>
              </div>

              <strong>Storage:</strong>

              <div class="bean-row">
                  <label>
                          <input type="radio" name="priority14" [value]="1" [(ngModel)]="model.priority14" (click)="selectQ14()" (change)="updateFourteen()"/> <b>(-1)</b> <br>Minimum amount
                      </label>
                  <label>
                          <input type="radio" name="priority14" [value]="2" [(ngModel)]="model.priority14" (click)="selectQ14()" (change)="updateFourteen()"/> <b>(-2)</b> <br>Average storage
                      </label>
                  <label>
                          <input type="radio" name="priority14" [value]="3" [(ngModel)]="model.priority14" (click)="selectQ14()" (change)="updateFourteen()"/> <b>(-3)</b> <br>Good, adequate storage
                      </label>
              </div>

              <strong>Amenities:</strong>

              <div class="bean-row">
                  <label>
                          <input type="radio" name="priority15" [value]="1" [(ngModel)]="model.priority15" (click)="selectQ15()" (change)="updateFifteen()"/> <b>(-1)</b> <br>None
                      </label>
                  <label>
                          <input type="radio" name="priority15" [value]="2" [(ngModel)]="model.priority15" (click)="selectQ15()" (change)="updateFifteen()"/> <b>(-2)</b> <br>Party room
                      </label>
                  <label>
                          <input type="radio" name="priority15" [value]="3" [(ngModel)]="model.priority15" (click)="selectQ15()" (change)="updateFifteen()"/> <b>(-3)</b> <br>Party room, tennis courts, exercise equip-ment, pool
                      </label>
              </div>

              <div class="text-center activity-header" [ngClass]="balance >= 0 ? 'activity-header-success': 'activity-header-failure'">
                  <h1>Balance: {{ balance }}</h1>
              </div>
              <div class="text-center">
                  <h3 *ngIf="balance < 0">Try not to spend more than your balance next time!</h3>
              </div>
              <div *ngIf="flag" style="color:red; padding-top: 15px" class="text-center">
                  You must answer all questions and have a non-negative balance before moving on
              </div>
          </div>

      </div>
  </div>
</div>

<div class="container navigate-buttons">
  <button type="button" class="btn waves-dark w-25" (click)="goBack($event); resetFlag();"><i class="fas fa-angle-left mr-3"></i>{{backTitle}}</button>
  <button *ngIf="previewByAdmin || !delay || activityOneChecked() && balance >= 0" type="button" class="btn waves-dark w-25" (click)="goNext($event) && resetFlag();" [delay-click]="delay ? 30 : 0" delay-tooltip="Finish reading through instructions and answer all questions first.">{{nextTitle}}<i class="fas fa-angle-right ml-3"></i></button>
  <button *ngIf="!(previewByAdmin || !delay || activityOneChecked() && balance >= 0)" type="button" class="btn waves-dark w-25" (click)="setFlag()" style="background-color: #ffd782;">{{nextTitle}}<i class="fas fa-angle-right ml-3"></i></button>
</div>
